// extracted by mini-css-extract-plugin
module.exports = {"wrap":"qt-z","heading":"rt-z","items":"st-z","featureCss":"tt-z","disabled":"ut-z","imgCss":"vt-z"};